export default __webpack_public_path__ + "static/media/iconfinder_React.js_logo_1174949.78e61144.png";